import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { LoginService } from 'src/app/shared/services/login.service';

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.scss']
})
export class RecoverPasswordComponent extends BaseListComponent<any> implements OnInit {
  date = new Date();
  valid: boolean = false;
  recuperar: any = {
    cpf: '',
    key: '',
    senha: null,
    confirmarSenha: null,
  };

  constructor(
    private router: Router,
    public activatedRoute: ActivatedRoute,
    private loginService: LoginService,
  ) {
    super()
  }

  ngOnInit() {
    this.loaded();
    this.valid = this.activatedRoute.snapshot.data['recoverValid'];
    this.recuperar.key = this.activatedRoute.snapshot.params['id'];
  }

  alterarSenha() {
    this.loading();
    this.loginService.updateRecuperarSenha(this.recuperar).subscribe({
      next: (value) => {
        this.confirmation("Senha alterada com sucesso").subscribe(() => {
          this.router.navigate(['login']);
        })
        this.loaded();
      },
      error: (err) => {
        this.loaded()
        this.msgError(typeof err.error !== 'object' ? err.error : err.message);
      },
    })
  }
}
